import { apiSlice } from "./ApiSlice";

const PharmacyStockApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        createNewCompany: builder.mutation({
            query: data => {
                return {
                    url: '/stock-AddMedicineCompany',
                    method: 'POST',
                    body: data,
                }
            }
        }),
        getMedCompany: builder.query({
            query: ({ pharmaId, medCompany }) => {
                console.log("pharmaId:", pharmaId, "medCompany:", medCompany);
                return {
                    url: `/Stock-GetMedicineCompanyList?pharmaId=${pharmaId}&MedicineCompanyName=${medCompany}`,
                    method: 'GET',
                }
            }
        }),
        addNewMedicine: builder.mutation({
            query: data => {
                return {
                    url: 'Stock-AddProduct',
                    method: 'POST',
                    body: data,
                }
            }
        }),
        getAllMeds: builder.query({
            query: ({ pharmaId, productname }) => {
                return {
                    url: `Stock-GetPharmaProductList?pharmaId=${pharmaId}&productname=${productname}`,
                    method: 'GET',
                }
            }
        }),

        addNewBatch: builder.mutation({
            query: data => {
                return {
                    url: 'Stock-InsertPharmaSearchBatch',
                    method: 'POST',
                    body: data,
                }
            }
        }),

        searchBatch: builder.query({
            query: data => {
                return {
                    url: `Stock-GetSearchBatchList?pharmaId=${data.pharmaId}&ProductID=${data.productid}&batchnum=${data.batch}`,
                    method: 'GET',
                }
            }
        }),

        insertOrUpdateBatch: builder.mutation({
            query: data => {
                return {
                    url: '/Stock-InsertorUpdateNewBatch',
                    method: 'POST',
                    body: data,
                }
            }
        }),

    })
})

export const { useCreateNewCompanyMutation, useLazyGetMedCompanyQuery, useAddNewMedicineMutation, useLazyGetAllMedsQuery, useAddNewBatchMutation, useLazySearchBatchQuery, useInsertOrUpdateBatchMutation } = PharmacyStockApiSlice; 